import { render } from "./EditPaymentLiquidation1.vue?vue&type=template&id=066d3274"
import script from "./EditPaymentLiquidation1.vue?vue&type=script&lang=js"
export * from "./EditPaymentLiquidation1.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__